<template>
  <div class="mylimni-logo">
    <img
      src="/images/logo/logo-wobg-lowres.png"
      alt="Mylimni Logo"
      style="height: 40px"
    >
  </div>
</template>

<script lang="ts" setup>
/**
 * @component MylimniLogo
 * @description WHAT: Mylimni application logo component. WHY: Provides consistent branding across the app. WHEN: Used in navigation bars and headers. HOW: Renders Mylimni logo image.
 */
// Logo with image
</script>

<style lang="scss" scoped>
.mylimni-logo {
  display: flex;
  align-items: center;
  height: 100%;
}
</style>
